import { UtilsTS } from "@/utilsts"
import { ModelSagres } from "../../model-sagres"

export class ConvenioResumido extends ModelSagres {
    IdConvenio: number
    NumeroAnoConvenio: string
    Tipo: string
    Objeto: string
    Valor: number
    DtInicioVigencia: Date
    DtFimVigencia: Date
    DtCelebracao: Date
    VigenciaFormatada?: string
    ValorFormatado: string
    CdSituacao: string

    tratarDadosDaAPI(): void {
        if (this.DtInicioVigencia) {
            this.DtInicioVigencia = new Date(this.DtInicioVigencia)
        }
        if (this.DtFimVigencia) {
            this.DtFimVigencia = new Date(this.DtFimVigencia)
        }
        if (this.DtCelebracao) {
            this.DtCelebracao = new Date(this.DtCelebracao)
        }
        this.calcularVigenciaFormatada()
        this.calcularValorFormatado()
        this.calcularSituacaoFormatada()        
    }

    calcularVigenciaFormatada(): void {
        if (this.DtInicioVigencia && this.DtFimVigencia)
            this.VigenciaFormatada = this.DtInicioVigencia.toLocaleDateString() + ' - ' + this.DtFimVigencia.toLocaleDateString()
        else
            this.VigenciaFormatada = ''

    }

    calcularValorFormatado(): void {
        if(this.Valor) {
            const utils = new UtilsTS()
            this.ValorFormatado = utils.formatMoeda(this.Valor)
        }
        else {
            this.ValorFormatado = "-"
        }
    }

    calcularSituacaoFormatada(): void {
        switch (this.CdSituacao) {
            case "FI":
               this.CdSituacao = "Cadastrado"
               break;
            case "EM":
                this.CdSituacao = "Em Cadastramento"
                break;
            case "AN":
                this.CdSituacao = "Cancelado"
                break;     
            default:
                this.CdSituacao = "-"
                break;
        }
    } 
}